import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SiteProvider, useSite } from './context/SiteContext';
import { FrontEndRoutes } from './config/front-end-routes';
import Header from './components/Header';
import Home from './components/Home';
import Services from './components/Services';
import Team from './components/Team';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import TrackingPixels from './components/TrackingPixels';
import WhatsAppButton from './components/WhatsAppButton';
import ServiceLanding from './components/landing/ServiceLanding';
import './styles/custom-bootstrap.scss';

const AppContent: React.FC = () => {
  const { loading, config } = useSite();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-profile-5">
        <div className="text-center">
          <div className="spinner-border text-profile-1 mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <h5 className="text-profile-1">Carregando informações...</h5>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <TrackingPixels />
      <Routes>
        {/* Site principal — rotas fixas com Header/Footer */}
        {[
          { path: FrontEndRoutes.HOME, element: <Home /> },
          ...(config?.show_services !== false ? [{ path: FrontEndRoutes.SERVICES, element: <Services /> }] : []),
          ...(config?.show_team !== false ? [{ path: FrontEndRoutes.TEAM, element: <Team /> }] : []),
          ...(config?.show_about !== false ? [{ path: FrontEndRoutes.ABOUT, element: <About /> }] : []),
          ...(config?.show_contact !== false ? [{ path: FrontEndRoutes.CONTACT, element: <Contact /> }] : []),
        ].map(({ path, element }) => (
          <Route key={path} path={path} element={
            <><Header />{element}<Footer /><WhatsAppButton /></>
          } />
        ))}

        {/* Landing pages — sem Header/Footer (captura slugs dinâmicos) */}
        <Route path={FrontEndRoutes.LANDING} element={<ServiceLanding />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <SiteProvider>
      <AppContent />
    </SiteProvider>
  );
}

export default App;
